/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {Breadcrumb as ScufBreadcrumb} from "@scuf/common";
import {withRouter} from "react-router";


class BreadCrumb extends React.Component {

    getBreacrumbItems(items) {
        return items.map((item) => {
            return <ScufBreadcrumb.Item key={item.url+item.name} onClick={item.url ? (() => this.props.history.push(item.url)) : undefined}>
                {item.name}
            </ScufBreadcrumb.Item>
        })
    }

    render() {

        const items = this.getBreacrumbItems(this.props.items)

        return (
            <ScufBreadcrumb>
                {items}
            </ScufBreadcrumb>
        )
    }
}


export default withRouter(BreadCrumb)